const getDate = (createdAt) => {
    if (!createdAt) return '';

    const date = new Date(createdAt);

    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export default getDate;